import empty from '@/router/modules/result';
import { BLANK_LAYOUT, IFRAME, LAYOUT } from '@/utils/route/constant';

// vite 3+ support dynamic import from node_modules

const LayoutMap = new Map<string, () => Promise<typeof import('*.vue')>>();

LayoutMap.set('LAYOUT', LAYOUT);
LayoutMap.set('BLANK', BLANK_LAYOUT);
LayoutMap.set('IFRAME', IFRAME);

/**
 * 默认路由
 *
 * 此时使用用户路由的第一个路由，也就是用户中心
 */
export const defaultRoute = empty[0];
